import { createContext, useContext } from "react";
import { User, Session } from "@supabase/supabase-js";

/**
 * M-1 PR-d: AuthContext reduzido a tipos + Context + hook.
 *
 * O Provider agora vive em `./AuthBridge.tsx` e usa exclusivamente
 * `@pps/auth-client` (sem fallback legado, sem feature flag). O shim
 * blue-green (AuthContext.shim.tsx) e a flag VITE_USE_PPS_AUTH foram
 * removidos após HML 5/5 OK.
 *
 * Os 45+ call sites continuam importando `useAuth` daqui sem alteração —
 * o `AuthBridge` republica os valores neste mesmo Context.
 */
export interface Profile {
  id: string;
  user_id: string;
  full_name: string | null;
  avatar_url: string | null;
  level: string | null;
  preferred_sport_id: string | null;
  preferred_language: string;
  preferred_currency: string;
  country_code: string | null;
}

export interface AuthContextType {
  user: User | null;
  session: Session | null;
  profile: Profile | null;
  loading: boolean;
  signUp: (email: string, password: string, fullName?: string) => Promise<{ error: Error | null }>;
  signIn: (email: string, password: string) => Promise<{ error: Error | null }>;
  signOut: () => Promise<void>;
  refreshProfile: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
